import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Button, Stack } from '@mui/material';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bayer from '/@/components/icon/assets/bayer.svg';
import LocalePreferences from '/@/components/locale-preferences';
import settings from '/@/core/settings';
import { setPreferences } from '/@/store/session/actions';
import { getAppInstance, getSessionCountry, getSessionLanguage } from '/@/store/session/selectors';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const Container = (props) => {
    const country = useSelector((state) => getSessionCountry(state));
    const language = useSelector((state) => getSessionLanguage(state));
    const dispatch = useDispatch();
    const isMobile = useIsMobile();
    const setLanguageAndCountry = bindActionCreators(setPreferences, dispatch);
    const appInstance = useSelector(getAppInstance);
    const enableFieldviewBlockingModal = appInstance?.enableFieldviewBlockingModal;

    const { t } = useTranslation();

    const renderButtons = () => {
        return (
            <Stack direction='column' spacing={2}>
                <Button
                    fullWidth
                    variant='outlined'
                    color='white'
                    sx={{
                        display: { md: 'none' },
                        py: 1.7,
                        zIndex: 10,
                    }}
                    onClick={props.handleGoToLogin}
                >
                    {t('Ingresar o Crear una cuenta ')}
                </Button>
                {!enableFieldviewBlockingModal && (
                    <Button
                        variant='contained'
                        color='white'
                        sx={{ width: { xs: '100%', md: 'fit-content' }, zIndex: 10 }}
                        onClick={props.showCatalog}
                        endIcon={<ArrowForwardIcon />}
                    >
                        {t('Accedé a nuestro Catálogo')}
                    </Button>
                )}
            </Stack>
        );
    };

    return (
        <div className={styles.root}>
            {settings.app.theme === 'expertobayer' && (
                <>
                    <Box
                        sx={{
                            position: 'absolute',
                            width: 0,
                            height: 0,
                            borderStyle: 'solid',
                            zIndex: 10,
                            left: 0,
                            borderWidth: { xs: '250px 150px 0 0', md: '300px 200px 0 0' },
                            borderColor: 'white transparent transparent transparent',
                            transform: 'rotate(0deg)',
                        }}
                    />
                    <img
                        src={Bayer}
                        alt='bayer icon'
                        style={{
                            position: 'absolute',
                            top: isMobile ? 70 : 30,
                            left: isMobile ? 10 : 30,
                            zIndex: 20,
                            width: 56,
                        }}
                    />
                </>
            )}
            <div>
                <div className={classNames(styles.girl, styles[`${settings.app.theme}-girl`])} />
                <div
                    className={classNames(
                        settings.app.theme === 'expertobayer' ? styles.expertoBayerImage : styles.image,
                        styles.leftImage,
                        isMobile && styles.mobileHeight
                    )}
                >
                    <div className={styles.leftContainer}>
                        <div>
                            {!isMobile && (
                                <div className={styles.preferences}>
                                    <LocalePreferences
                                        whiteColor={false}
                                        openUp
                                        appearance='row'
                                        showLabels={false}
                                        country={country.id}
                                        language={language}
                                        onChange={(payload) => setLanguageAndCountry(payload)}
                                        showCountry
                                        handleCountryChange={() => {}}
                                        className={styles.language}
                                        classNameOptions={styles.languageOptions}
                                        showLanguage={props.showLanguage}
                                        upperCase
                                    />
                                </div>
                            )}
                            <div>
                                <Title
                                    color='white'
                                    className={classNames(
                                        styles.title,
                                        settings.app.theme === 'expertobayer' && styles.expertoBayerTitle
                                    )}
                                >
                                    {t('Te damos la bienvenida a {{appName}}', { appName: settings.app.name })}
                                </Title>
                                <Title color='white' size='md' bolder className={styles.description}>
                                    {t(
                                        '{{appName}} es la herramienta del equipo comercial y los Distribuidores autorizados por Bayer, para generar recomendaciones con datos reales y acompañar a los productores de punta a punta.',
                                        { appName: settings.app.name }
                                    )}
                                </Title>
                            </div>
                        </div>
                        {!props.hideButtons && renderButtons()}
                    </div>
                </div>
            </div>

            <div className={styles.rightContainer}>{props.children}</div>
        </div>
    );
};

export default Container;
